import React, { useState, useEffect } from 'react';
import { Column } from 'rbx';
import gql from 'graphql-tag';
import moment from 'moment';
import { isNull } from 'lodash';

import { Input } from '../../../components/elements';
import client from '../../../utils/apolloClient';
import UserSocialCounts from './UserSocialCounts';

const userQuery = gql`
  query user($userId: String!) {
    fetch_user(input: { user_id: $userId }) {
      user_id
      object_id
      first_name
      last_name
      display_name
      preferred_username
      email
      status
      rating
      audit {
        created_at
        created_by
        updated_at
        updated_by
      }
    }
  }
`;

const FlaggedUserDetails = ({
  flag,
  createdBy,
  createdTime,
  userFlagData,
  userItemReviewCount,
  userPlaceReviewCount,
}) => {
  const [user, setUser] = useState();

  useEffect(() => {
    client.clientPrivate
      .query({
        query: userQuery,
        variables: { userId: createdBy },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => {
        if (data) {
          setUser(data.fetch_user);
        }
      });
  }, []);

  return (
    <fieldset className="box">
      <legend className="label">Flagged User Details</legend>
      <Column.Group multiline vcentered gapSize={8}>
        <Column size="half">
          <Input label="Email" value={user && user.email} disabled />
        </Column>
        <Column size="half">
          <Input
            label="Display Name"
            value={user && user.display_name}
            disabled
          />
        </Column>
        <Column size="half">
          <Input
            label="Flagged On"
            value={moment(createdTime).format('lll')}
            disabled
          />
        </Column>
        <Column size="half">
          <Input label="Status" value={user && user.status} disabled />
        </Column>
        <Column size={3}>
          <Input
            label="User Rating"
            value={isNull(user && user.rating) ? 0 : user && user.rating}
            disabled
          />
        </Column>
        <UserSocialCounts
          flag={flag}
          userPlaceReviewCount={userPlaceReviewCount}
          userItemReviewCount={userItemReviewCount}
          userFlagData={userFlagData}
        />
      </Column.Group>
    </fieldset>
  );
};

export default FlaggedUserDetails;
